const clientCapMenu = [
    {
        label: "Dashboard",
        icon: "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"3\" y=\"3\" width=\"7\" height=\"7\" stroke=\"currentColor\" stroke-width=\"2\"/><rect x=\"14\" y=\"3\" width=\"7\" height=\"7\" stroke=\"currentColor\" stroke-width=\"2\"/><rect x=\"14\" y=\"14\" width=\"7\" height=\"7\" stroke=\"currentColor\" stroke-width=\"2\"/><rect x=\"3\" y=\"14\" width=\"7\" height=\"7\" stroke=\"currentColor\" stroke-width=\"2\"/></svg>",
        href: "/dashboard"
    },
    {
        label: "Solicitudes",
        icon: "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 3H16L20 7V21H4V3Z\" stroke=\"currentColor\" stroke-width=\"1.8\"/><path d=\"M8 7H16\" stroke=\"currentColor\" stroke-width=\"1.8\"/></svg>",
        href: "/requests",
        children: [
            {
                label: "Crear Solicitudes",
                href: "/requests"
            },
            {
                label: "Carga masiva",
                href: "/requests/file-upload"
            },
            {
                label: "Consultar Solicitudes",
                href: "/requests/process-requests"
            },
            {
                label: "Endosos sin movimientos",
                href: "/requests/endorsments-without-movement"
            },
            {
                label: "Endosos con movimientos",
                href: "/requests/endorsments-with-movement"
            }
        ]
    },
    {
        label: "Siniestros",
        icon: "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3.05h16.94a2 2 0 0 0 1.71-3.05l-8.47-14.14a2 2 0 0 0-3.42 0z\" stroke=\"currentColor\" stroke-width=\"2\"/><line x1=\"12\" y1=\"9\" x2=\"12\" y2=\"13\" stroke=\"currentColor\" stroke-width=\"2\"/></svg>",
        href: "/claims",
        children: [
            {
                label: "Declarar Siniestros",
                href: "/claims"
            },
            {
                label: "Consultar Siniestros",
                href: "/claims/process-claims"
            }
        ]
    },
    {
        label: "Borderaux de siniestros",
        icon: "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 2v20M5 7h14M5 17h14\" stroke=\"currentColor\" stroke-width=\"2\"/></svg>",
        href: "#"
        // este item ejecutaba exportPayment (acción, no navegación)
    },
    {
        label: "Generales",
        icon: "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"12\" cy=\"8\" r=\"4\" stroke=\"currentColor\" stroke-width=\"2\"/><path d=\"M4 20c0-4 16-4 16 0\" stroke=\"currentColor\" stroke-width=\"2\"/></svg>",
        href: "/usuario"
    }
];

export default clientCapMenu;